import { useEffect, useState } from 'react';
import { useDebounce } from './use-debounce';

export interface IWindowSize {
	width: number | undefined;
	height: number | undefined;
}

export const useWindowSize = (debounce: number): IWindowSize => {
	const [windowSize, setWindowSize] = useState(getSize);
	const debouncedWindow: IWindowSize = useDebounce(windowSize, debounce);

	const handleSize = (): void => {
		setWindowSize(getSize());
	};

	useEffect(() => {
		window.addEventListener('resize', handleSize);
		window.addEventListener('orientationchange', handleSize);

		return (): void => {
			window.removeEventListener('resize', handleSize);
			window.removeEventListener('orientationchange', handleSize);
		};
	}, []);

	return debouncedWindow;
};

const getSize = (): IWindowSize => {
	const isClient = typeof window === 'object';

	return {
		width: isClient ? window.innerWidth : undefined,
		height: isClient ? window.innerHeight : undefined
	};
};
